<template>
  <div class="row child-row">
    <div class="col-12">
      <div class="child-row__title pb-3">Changes</div>
      <div v-if="hasChanges" class="easy-data-table-dark">
        <table class="table table-sm table-bordered mb-0">
          <thead>
            <tr>
              <th style="width: 25%">Field</th>
              <th style="width: 35%">Old value</th>
              <th style="width: 5%" class="text-center" />
              <th style="width: 35%">New value</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in changeRows" :key="row.field">
              <td><b>{{ row.label }}</b></td>
              <td>
                <AuditValue :value="row.oldValue" />
              </td>
              <td class="text-center">
                <i class="fa fa-arrow-right text-muted" />
              </td>
              <td>
                <AuditValue :value="row.newValue" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else class="text-muted">No changes recorded</div>
    </div>
  </div>
</template>

<script lang="ts">
import type { AuditLogItem } from '@/types/Models/AuditLog'
import { computed, defineComponent, type PropType } from 'vue'
import { useAuditLogDetails } from '@/composables/AuditLog/useAuditLogDetails'
import AuditValue from '@/views/Staff/AuditLog/AuditValue.vue'

export default defineComponent({
  name: 'AuditLogDetails',
  components: { AuditValue },
  props: {
    log: {
      type: Object as PropType<AuditLogItem>,
      required: true,
    },
  },
  setup(props) {
    const logRef = computed(() => props.log)
    const { changeRows, hasChanges } = useAuditLogDetails(logRef)

    return { changeRows, hasChanges }
  },
})
</script>
